import React, {
  FunctionComponent as FC,
  useRef,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux'; // To call Action Creators
import { State } from '../../../../../../state';
import * as d3 from 'd3';
import _ from 'lodash';
import './index.scss';

import { GrantGlyphType, CitationFlowType, ImpactType } from '../../../../../../types/data.global';

interface PredictionGlyphProps {
  id: number;
  grantGroupName: string;
  // grant_field_name: string;
  glyphDataHistorical: any;
  glyphDataPredicted: any;
  glyphStyle: any;
  centerGrantNode_MaxMin: number[];
}

const PredictionGlyph: FC<PredictionGlyphProps> = (props) => {

  const { id, grantGroupName, glyphDataHistorical, glyphDataPredicted, glyphStyle, centerGrantNode_MaxMin } = props

  // console.log('centerGrantNode_MaxMin: ', centerGrantNode_MaxMin)

  // console.log('\n\n\=========== PredictionGlyph: ============')
  // console.log('glyphDataHistorical: ', glyphDataHistorical.grant_field_code, glyphDataHistorical.num_grant)
  // console.log('glyphDataPredicted: ', glyphDataPredicted.grant_field_id, glyphDataPredicted.num_grant)
  // console.log('grantGroupName: ', grantGroupName)


  // ui reducer
  const citationFlowType: string = useSelector((state: State) => state.uiReducer?.citationFlowType) as string

  const [textLabelVisibility, setTextLabelVisibility] = useState('hidden')

  // draw glyph
  const numGrantGlyphR: number = glyphStyle.glyphMaxR * glyphStyle.minR_Ratio.directImpact * 0.7
  const numGrantHistorical: number = glyphDataHistorical.num_grant
  let numGrantPredicted: number = 0
  if (!_.isEmpty(glyphDataPredicted)) {
    numGrantPredicted = glyphDataPredicted.num_grant

    // [abandon] vis2024 version
    // numGrantPredicted = numGrantPredicted * 50 // 15 (case 1), 50 temp, hard code, numGrantPredicted实在太小了，看不出圆环区别
  }
  const numGrantSum = numGrantHistorical + numGrantPredicted
  // console.log('numGrantSum: ', numGrantSum)
  // console.log('numGrantHistorical: ', numGrantHistorical)
  // console.log('numGrantPredicted: ', numGrantPredicted)
  // console.log('\n\n')

  const glyphRScale = d3.scalePow() // scaleLinear, scaleSymlog
    .domain([0, numGrantSum])
    .range([0, numGrantGlyphR])
    .exponent(5) // > 1: 让数字大的更大，小的更小

  // // linear scale
  // const nodeScale = (numGrantHistorical - centerGrantNode_MaxMin[0]) / (centerGrantNode_MaxMin[1] - centerGrantNode_MaxMin[0])
  // log scale
  const nodeScaleLog = d3.scaleLog()
    .domain([centerGrantNode_MaxMin[0], centerGrantNode_MaxMin[1]]) // domain should start from a positive number, not zero
    .range([0.2, 1]);
  const nodeScale = nodeScaleLog(numGrantHistorical)
  // console.log('nodeScale: ', nodeScale)

  // Draw the historical circle
  const historicalCircle = <circle cx={0} cy={0} r={glyphRScale(numGrantHistorical)}
    id={`prediction-glyph--numGrantHistorical-${numGrantHistorical}`}
    fill={`url(#grant-glyph-prediction)`}
    // filter="url(#filter-grant-glyph-prediction)"

    // fill='#b08968'
    // fillOpacity={0.6}
    // fill={`url(#RCI-glyph-test)`}
    // fill={`url(#RCI-glyph-directImpact)`}
    // stroke='white' strokeWidth={2}
    strokeOpacity={1}/>

  // Draw the predicted circle
  const predictedCircle = <circle
      cx={0} cy={0}
      r={glyphRScale(numGrantSum)}
      id={`prediction-glyph--numGrantSum-${numGrantSum}`}
      fill='#AE7BAC'
      stroke='none'
      // stroke='white'
  />

  let scale = 1
  if (citationFlowType === CitationFlowType.PREDICTION) {
    scale = 3 // temp, hard code. TODO: move this parameter to `style.global.ts`
  }
  const glyphGroup: JSX.Element = <g id={`prediction-g-${grantGroupName}`} transform={`scale(${scale * nodeScale})`}>
    { (citationFlowType === CitationFlowType.PREDICTION) ? predictedCircle : <></>}
    {historicalCircle}
    {/* <text x={0} y={0} dx={-30} dy={-30} textAnchor="middle" fontSize={8} fill="black">
      {numGrantSum}
    </text> */}
  </g>

  return (
    <g key={`prediction-g-${id}-${grantGroupName}`}>
      {glyphGroup}
      {/* <text x={0} y={0} dx={+60} dy={-20} textAnchor="middle" fontSize={8} fill="black" transform='rotate(-30)'>
        {grantGroupName}
      </text> */}
      <text x={0} y={0} dx={+0} dy={+42} textAnchor="middle" fontSize={10} fill="#404040" transform='rotate(0)'>{grantGroupName}</text>
      {/* <text x={0} y={0} dx={+0} dy={+60} textAnchor="middle" fontSize={8} fill="#333333" transform='rotate(0)'>{grantGroupName}</text> */}
    </g>
  )
}

export default PredictionGlyph;